/**
 * Web 路由配置（基础路由）
 */
const BASE_ROUTER_PATH = {
  /** @deprecated 使用 INVEST；保留键名减少调用方改动 */
  ALPHA_PICK: "/invest",
  ALPHA_PICK_PICKS: "/invest/picks",
  // invest/portfolio/import
  ALPHA_PICK_PORTFOLIO_IMPORT: "/invest/portfolio/import",
  ALPHA_PICK_CURRENT_PICKS: "/invest/picks/current",
  ALPHA_PICK_FINANCIAL_REPORTS_HISTORY: "/invest/earnings/upcoming",
  ALPHA_PICK_FINANCIAL_DETAIL: "/invest/earnings",
  ALPHA_PICK_IPO: "/invest/ipo",
  NOTIFICATION: "/notification",
  /** @deprecated 使用 DESK；保留键名减少调用方改动 */
  TRACKERS: "/desk",
  DESK: "/desk",
  DESK_LIST: "/desk/list",
  DESK_DETAIL: "/desk/:id",
  /** @deprecated 使用 DESK_LIST */
  TRACKERS_LIST: "/desk/list",
  /** @deprecated 使用 DESK_DETAIL */
  TRACKER_DETAIL: "/desk/:id",

  HOME: "/brief",
  ABOUT: "/",
  LOGIN: "/login",
  /** 邀请码填写页（登录流二级页，Figma 104980:320350）；落地页仍是 /task/invite/:code */
  INVITE_CODE: "/invite-code",
  CHAT: "/chat",
  /** App 独立 Chat WebView（底部 modal 壳 Tab 3 seed） */
  APP_CHAT_MODAL: "/app-chat-modal",
  CHAT_HISTORY: "/history",
  CHAT_SHARE: "/chat/share",
  HISTORY: "/history",
  SEARCH: "/search",
  SEARCH_TOKEN: "/search/token",
  AURA: "/aura",
  AURA_REBATE: "/aura/rebate",
  AURA_PROFILE: "/task",
  GOAL: "/goal",
  GOAL_DETAIL: "/goal/:id",
  ARTICLE_LIST: "/article",

  MARKET: "/market",
  MARKET_CRYPTO: "/market/crypto",

  RADAR_HK_STOCK: "/market/hk-stocks",
  RADAR_US_STOCK: "/market/us-stocks",

  RADAR_BLUECHIP: "/market/crypto/blue-chip-tokens",
  RADAR_HOT_X: "/market/crypto/crypto-mindshare",
  RADAR_JUST_FUNDRAISED: "/market/crypto/just-fundraised",
  RADAR_TRENDING: "/market/crypto/dex-tracker",

  CHART: "/chart",
  CRYPTO_TOKEN: "/crypto",
  POOL_TOKEN: "/pool",
  STOCK_DETAIL: "/stock",
  ETF_DETAIL: "/etf",
  NEWS: "/news",
  MEMBER: "/member",
  /** 小屏「管理订阅」页；大屏路由层 `notFound` */
  MEMBER_SUBSCRIPTION: "/member/subscription",
  PIVOT_ALERT: "/pivot-alert",
  NEXT_ABOUT: "/about/_next",
  NEXT: "/_next",
  SETTING: "/setting",

  // Portfolio routes
  PORTFOLIO: "/portfolio",

  CO_PILOT: "/copilot",
  CO_PILOT_PORTFOLIO: "/portfolio",
  CO_PILOT_PORTFOLIO_IMPORT: "/portfolio/import",
  NEWS_CRYPTO: "/news/crypto",
  NEWS_TITLE_DETAIL: "/news/post",
  NEWS_AUTHOR_DETAIL: "/author/news",
  ARTICLE_AUTHOR_DETAIL: "/author/article",

  THEMES_CRYPTO: "/themes/crypto",
  THEMES_US_STOCK: "/themes/us-stocks",
  THEMES_HK_STOCK: "/themes/hk-stocks",

  DISCOVER: "/discover",
  DISCOVER_US_STOCKS: "/discover/us-stocks",

  HOME_CRYPTO: "/discover/crypto",
  HOME_STOCK: "/discover/us-stocks",
  DISCOVER_HK_STOCKS: "/discover/hk-stocks",
  DISCOVER_CRYPTO: "/discover/crypto",

  WHALE_HOLDINGS: "/whale-holdings",

  EDGEN_AI_RANKING: "/edgen-ai/ranking",

  // /invest
  INVEST: "/invest",
  INVEST_ACTIVITY: "/invest/activity",
  INVEST_OPPORTUNITY: "/invest/opportunity",
  INVEST_PORTFOLIO: "/invest/portfolio",
  INVEST_MARKET_STOCK: "/invest/stock",
  INVEST_MARKET_ETF: "/invest/etf",
  INVEST_MARKET_CRYPTO: "/invest/crypto",

  // /brief
  BRIEF: "/brief",

  // /plan
  PLAN: "/plan",
  PLAN_CHECKUP: "/plan/checkup",
  PLAN_MY_GOALS: "/plan/my-goals",
  /** Track → My money（PlanDashboardShell）；旧 `/plan/dashboard` 仅 soft redirect */
  PLAN_DASHBOARD: "/desk?tab=my_money",

  // /desk/:id
  /** @deprecated 使用 DESK_DETAIL */
  TRACKERS_ID: "/desk/:id",

  // /my (financial fitness)
  MY: "/my",
  MY_SCORE: "/my",
  /**
   * @deprecated 已无落点。`MyPage.tsx` 只渲染 `MyScoreTab`、无视 `?tab=goals`；
   * 唯一使用者（抽屉「Goal」项）已于 V3.0.4 删除。goals 请用 `PLAN_MY_GOALS`。
   */
  MY_GOALS: "/my?tab=goals",
  MY_ACCOUNTS: "/my-accounts",

  ONBOARDING: "/onboarding",
  WELCOME: "/welcome",
  STORY: "/story",
};

/**
 * 手机路由配置（直接从 routerOfApp.json 导入）
 */
const MOBILE_ROUTER_PATH = {
  /** @deprecated 使用 MOBILE_MAIN_TAB_INVEST */
  MOBILE_MAIN_TAB_ALPHA: BASE_ROUTER_PATH.INVEST_OPPORTUNITY,
  // /discover
  MOBILE_MAIN_TAB_ALPHA_DISCOVER: BASE_ROUTER_PATH.DISCOVER,
  // /discover/us-stocks
  MOBILE_MAIN_TAB_ALPHA_DISCOVER_US: BASE_ROUTER_PATH.DISCOVER_US_STOCKS,
  // /news/stock
  MOBILE_MAIN_TAB_NEWS: BASE_ROUTER_PATH.NEWS,
  // /portfolio
  MOBILE_MAIN_TAB_ALPHA_PORTFOLIO: BASE_ROUTER_PATH.PORTFOLIO,
  // /task
  MOBILE_MAIN_TAB_TASK: BASE_ROUTER_PATH.AURA_PROFILE,
  // /invest/opportunity
  MOBILE_MAIN_TAB_INVEST: BASE_ROUTER_PATH.INVEST_OPPORTUNITY,
  // /desk
  /** @deprecated 使用 MOBILE_MAIN_TAB_DESK */
  MOBILE_MAIN_TAB_TRACKERS: BASE_ROUTER_PATH.DESK,
  MOBILE_MAIN_TAB_DESK: BASE_ROUTER_PATH.DESK,
  // /brief
  MOBILE_MAIN_TAB_BRIEF: BASE_ROUTER_PATH.BRIEF,
  // /plan
  MOBILE_MAIN_TAB_PLAN: BASE_ROUTER_PATH.PLAN,
};

/**
 * 路由代理对象
 * 使用 Proxy 实现动态路由访问
 */
export const ROUTER_PATH = new Proxy(
  {} as typeof BASE_ROUTER_PATH & { mobile: typeof MOBILE_ROUTER_PATH },
  {
    get(_target, prop: string | symbol) {
      // 处理 mobile 属性访问
      if (prop === "mobile") {
        return MOBILE_ROUTER_PATH;
      }

      // 处理字符串属性访问
      if (typeof prop === "string") {
        const key = prop;

        // 直接返回 Web 路由值
        if (key in BASE_ROUTER_PATH) {
          return BASE_ROUTER_PATH[key as keyof typeof BASE_ROUTER_PATH];
        }
      }

      // 默认返回 undefined
      return undefined;
    },
  },
) as typeof BASE_ROUTER_PATH & { mobile: typeof MOBILE_ROUTER_PATH };

/**
 * 构建 `/news` 下路径的选项（不含 `[device]` 段）。
 * - `localePathPrefix`：与 `buildLocale` / `buildLocalePrefix` 一致，默认语为 `""`，否则为 `/${locale}`。
 * - `siteOrigin`：传入则返回绝对 URL（无尾斜杠），如 `https://www.edwealth.ai`。
 */
export type BuildNewsPathOptions = {
  localePathPrefix?: string;
  siteOrigin?: string;
};

function normalizeNewsPath(
  localePathPrefix: string | undefined,
  ...segments: string[]
): string {
  const prefix = (localePathPrefix ?? "").replace(/\/+$/, "");
  const tail = segments.filter(Boolean).join("/");
  const newsPath = tail
    ? `${BASE_ROUTER_PATH.NEWS}/${tail}`
    : BASE_ROUTER_PATH.NEWS;
  return prefix ? `${prefix}${newsPath}` : newsPath;
}

function applyNewsSiteOrigin(path: string, siteOrigin?: string): string {
  if (!siteOrigin) {
    return path;
  }
  return `${siteOrigin.replace(/\/+$/, "")}${path}`;
}

/**
 * 统一构建 `/news` 相关 URL（不含 `[device]`）。
 */
export class NewsRoutePaths {
  /** `/news/{category}` */
  static hub(category: string, options?: BuildNewsPathOptions): string {
    const path = normalizeNewsPath(options?.localePathPrefix, category);
    return applyNewsSiteOrigin(path, options?.siteOrigin);
  }

  /** `/news/{channel}/{subTagSlug}` */
  static subTag(
    channel: string,
    subTagSlug: string,
    options?: BuildNewsPathOptions,
  ): string {
    const path = normalizeNewsPath(
      options?.localePathPrefix,
      channel,
      subTagSlug,
    );
    return applyNewsSiteOrigin(path, options?.siteOrigin);
  }
}
